import {AntTab, AntTabs, useStyles} from "./styles";
import {NavLink, useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {PageContext} from "../../../context/pages";
import {useLazyQuery, useMutation, useQuery} from "@apollo/client";
import {GET_ACCOUNT_SETTINGS, GET_PARTNER_CLIENT_ACCOUNT} from "../../../actions/get";
import Preloader from "../../../components/global/Preloader";
import {AntContainerHead} from "../../../theme/Wrapper";
import TabPanelLayout from "../../../components/global/tab/TabPanelLayout";
import DnsZones from "./tabs/dnsZones";
import IPAddressGroups from "./tabs/IPAddressGroups";
import ACLsComponent from "./tabs/acl";
import {Checkbox, FormControl, FormControlLabel, Radio, RadioGroup, Switch, Typography} from "@mui/material";
import {UPDATE_ACCOUNT_SETTINGS_L7} from "../../../actions/update";
import {toast} from "react-toastify";
import DatePicker from 'react-datepicker';

const DnsHosting = ({ dataPartnerClientAccount }) => {
    const classes = useStyles();
    const { subTab, id } = useParams();
    const [indexTab, setIndexTab] = useState(0);
    const { deleteFilter, filter, setFilter } = useContext(PageContext);
    const [switches, setSwitches] = useState(false);
    const [l7visibility, setL7visibility] = useState(null);
    const [trialPeriod, setTrialPeriod] = useState(new Date());
    const [switchTrialPeriod, setSwitchTrialPeriod] = useState(false);

    const accountSettingsId =
        dataPartnerClientAccount && dataPartnerClientAccount?.accountSettings?.id;

    const [getDataSettingApi, { data: dataSetting }] = useLazyQuery(GET_ACCOUNT_SETTINGS, {
        variables: {
            id: dataPartnerClientAccount && dataPartnerClientAccount?.accountSettings?.id,
        },
    });

    useEffect(() => {
        if (accountSettingsId) {
            getDataSettingApi();
        }
    }, [accountSettingsId]);

    useEffect(() => {
        if (dataPartnerClientAccount && dataPartnerClientAccount.accountSettings.l7.l7Limit >= 1) {
            setSwitches(true);
        } else {
            setSwitches(false);
        }
    }, [dataPartnerClientAccount]);

    // мутации связанные с updateAccountSettingsL7
    const [updateAccountSettingsL7Api] = useMutation(UPDATE_ACCOUNT_SETTINGS_L7, {
        onCompleted: () => toast.success('Success'),
        refetchQueries: [
            {
                query: GET_ACCOUNT_SETTINGS,
                variables: {
                    id: accountSettingsId,
                },
            },
        ],
    });

    const onChangeVisibleL7Service = (value) => {
        setL7visibility(value);
        updateL7Visibility(value);
    };

    const updateL7Visibility = (value) => {
        updateAccountSettingsL7Api({
            variables: {
                id: accountSettingsId,
                l7Limit: dataSetting?.accountSettings?.l7?.l7Limit,
                visibility: value,
            },
        });
    };

    const handleChangeTrialDatePicker = (date) => {
        setTrialPeriod(date);

        updateAccountSettingsL7Api({
            variables: {
                id: accountSettingsId,
                trialPeriodL7: date,
                l7Limit: dataSetting.accountSettings.l7.l7Limit,
                visibility: l7visibility,
            },
        });
    };

    const handleChangeTrialSwitch = (event) => {
        setSwitchTrialPeriod(event.target.checked);

        if (!event.target.checked) {
            setTrialPeriod(new Date());
            updateAccountSettingsL7Api({
                variables: {
                    id: accountSettingsId,
                    trialPeriodL7: null,
                    l7Limit: dataSetting?.accountSettings?.l7?.l7Limit,
                    visibility: l7visibility,
                },
            });
        } else {
            updateAccountSettingsL7Api({
                variables: {
                    id: accountSettingsId,
                    trialPeriodL7: trialPeriod,
                    l7Limit: dataSetting?.accountSettings?.l7?.l7Limit,
                    visibility: l7visibility,
                },
            });
        }
    };

    useEffect(() => {
        if (dataSetting && dataSetting.accountSettings?.l7) {
            const { trialPeriod, visibility } =
                dataSetting.accountSettings.l7;
            setSwitchTrialPeriod(Boolean(trialPeriod));
            setL7visibility(visibility);
            trialPeriod && setTrialPeriod(new Date(trialPeriod));
        }
    }, [dataSetting]);

    const handleChange = (event, newValue) => {
        setIndexTab(newValue);
    };

    const a11yProps = index => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };

    useEffect(() => {
        setIndexTab(Number(subTab));
    }, [subTab]);

    const { data, loading } = useQuery(GET_PARTNER_CLIENT_ACCOUNT, {
        variables: {
            id: Number(id),
        },
    });

    const deletedDnsLabel = [
        'Show deleted zones',
        'Show deleted IP address groups',
        'Show deleted ACLs groups'
    ]

    if (loading) return <Preloader />;

    return (
        <>
            <div className={classes.servicesContainer}>
                <div>
                    <div className={classes.radioWrap}>
                        <FormControl>
                            <div style={{ fontSize: '20px', marginBottom: '15px' }}>
                                Service visibility in client dashboard:
                            </div>
                            <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                                name="radio-buttons-group"
                                value={l7visibility}
                                onChange={(event) => {
                                    onChangeVisibleL7Service(event.target.value);
                                }}
                            >
                                <FormControlLabel value="INVISIBLE" control={<Radio />} label="INVISIBLE" />
                                <FormControlLabel value="DEMO" control={<Radio />} label="DEMO" />
                                <FormControlLabel value="VISIBLE" control={<Radio />} label="VISIBLE" />
                            </RadioGroup>
                        </FormControl>
                    </div>

                    <div className={classes.wrapperGroup}>
                        <div className={classes.pickerWrapper}>
                            <div className={classes.switchWrapper}>
                                <Switch name="trial" checked={switchTrialPeriod} onChange={handleChangeTrialSwitch} />
                            </div>

                            <Typography className={classes.text}>Trial period till:</Typography>

                            <div style={{ position: 'relative' }}>
                                <DatePicker
                                    onChange={handleChangeTrialDatePicker}
                                    selected={trialPeriod}
                                    disabled={!switchTrialPeriod}
                                    className={classes.dataPicker}
                                    dateFormat="dd.MM.yyyy"
                                    popperClassName={classes.poper}
                                    showPopperArrow={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.header}>
                    <div>
                        <FormControlLabel
                            style={{ marginRight: 40 }}
                            control={
                                <Checkbox
                                    checked={filter?.sort?.checked || false}
                                    onChange={(event) =>
                                        setFilter({
                                            ...filter,
                                            sort: { ...filter?.sort, checked: event.target.checked },
                                        })
                                    }
                                    name="checkedA"
                                    color="primary"
                                />
                            }
                            label={deletedDnsLabel[subTab]}
                        />
                    </div>
                </div>
            </div>

            <div position="static" className={classes.bar}>
                <AntContainerHead maxWidth={false}>
                    <AntTabs
                        value={indexTab}
                        onChange={handleChange}
                        className={classes.itemTab}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <AntTab
                            label="DNS hosting"
                            {...a11yProps(0)}
                            onClick={() => deleteFilter()}
                            to={`/edit-account/3/${id}/${0}`}
                            component={NavLink}
                            replace
                        />
                        <AntTab
                            label="IP address groups"
                            {...a11yProps(1)}
                            onClick={() => deleteFilter()}
                            to={`/edit-account/3/${id}/${1}`}
                            component={NavLink}
                            replace
                        />
                        <AntTab
                            label="ACLs"
                            {...a11yProps(1)}
                            onClick={() => deleteFilter()}
                            to={`/edit-account/3/${id}/${2}`}
                            component={NavLink}
                            replace
                        />
                    </AntTabs>
                </AntContainerHead>
            </div>
            <TabPanelLayout value={indexTab} index={0}>
                <DnsZones dataPartnerClientAccount={data && data.partnerClientAccount} />
            </TabPanelLayout>
            <TabPanelLayout value={indexTab} index={1}>
                <IPAddressGroups dataPartnerClientAccount={data && data.partnerClientAccount} />
            </TabPanelLayout>
            <TabPanelLayout value={indexTab} index={2}>
                <ACLsComponent dataPartnerClientAccount={data && data.partnerClientAccount} />
            </TabPanelLayout>
        </>
    );
}

export default DnsHosting;